import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { useDispatch } from "react-redux";
import upload from "../../../images/Upload.svg";
import { CreateBranchForVfs, VfsLoader } from "../../../Redux/Action/VfsAction";
import { useLocation } from "react-router";

export const CreateBranchModal = ({ setCorporatemodel,corporatemodel }) => {
  const dispatch = useDispatch();
  // get token from local storage
  const authToken = localStorage.getItem("Admin");
  const token = JSON.parse(authToken)?.data?.token;

  const [corporateName, setCorporateName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactno, setContactno] = useState("");
  const [uploadimages, setuploadimages] = useState([]);
  const [uploadimagesURLs, setuploadimagesURLs] = useState([]);
  const [ImageValidationError, setImageValidationError] = useState("");
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [primary, setPrimary] = useState("");
  const [secondary, setSecondary] = useState("");
  const [hContact , setHContact] = useState("2269063445");
  const [aContact , setAContact] = useState("2269063446");
  let errorsObj = { uploadimage: "", image: "" };
  const [errors, setErrors] = useState(errorsObj);

  useEffect(() => {
    if (uploadimages?.length < 1) return;
    const newImageURLs = [];
    uploadimages.forEach((image) =>
      newImageURLs.push(URL.createObjectURL(image))
    );
    setuploadimagesURLs(newImageURLs);
  }, [uploadimages]);

  const onuploadimagechange = (e) => {
    let error = false;
    const errorObj = { ...errorsObj };
    const file = e?.target?.files[0];
    setImageValidationError("");
    if (file) {
      const fileType = file.type;
      if (fileType === "image/gif") {
        errorObj.uploadimage =
          "Please upload an image with the .jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.webp extension";
        setErrors(errorObj);
        resetImageState();
        return;
      }
      if (file.size > 5000000) {
        errorObj.uploadimage = "The file should not be greater than 5 MB.";
        setErrors(errorObj);
        resetImageState();
        return;
      }
    }

    if (file) {
      const image = new Image();
      image.src = URL.createObjectURL(file);
      image.onload = () => {
        errorObj.uploadimage = "";
        setErrors(errorObj);
        setuploadimages([file]);
        setImageValidationError("");
      };

      image.onerror = () => {
        errorObj.uploadimage = "Invalid image file.";
        setErrors(errorObj);
        resetImageState();
        error = true;
      };
    }
    if (error) {
      return;
    }
  };
  const resetImageState = () => {
    setuploadimages([]);
    setuploadimagesURLs([]);
  };

  const location = useLocation();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors("");
    if (uploadimages.length === 0) {
      setImageValidationError("Please upload the profile logo.");
      return;
    }
    if (startDate && !endDate) {
      setError("Please select an End date.");
      return;
    }
    if (!startDate && endDate) {
      setError("Please select an Start date.");
      return;
    }
    const formattedStartDate = Math.floor(new Date(startDate).getTime());
    const formattedEndDate = Math.floor(new Date(endDate).getTime());
    const master_id =  JSON.parse(localStorage.getItem("Admin"))?.data?.corporateID;
    const sds = location.search.slice(1).split("&");
    let object = {};
    if (location.search.includes("?")) {
        sds.map((item) => {
            let newItem = item.split("=");
            object[newItem[0]] = newItem[1];
        });
    }
    try {
      const formData = new FormData();
      formData.append("logo", uploadimages[0]);
      formData.append("corporateName", corporateName);
      formData.append("name", name);
      formData.append("email", email);
      formData.append("contactno", contactno);
      formData.append("startdate", formattedStartDate);
      formData.append("enddate", formattedEndDate);
      formData.append("primary", primary);
      formData.append("secondary", secondary);
      formData.append("homContact", hContact);
      formData.append("aloContact", aContact);
      formData.append("master_CorpoId" , master_id);
      dispatch(CreateBranchForVfs(formData, { ...object} , setCorporatemodel));
      dispatch(VfsLoader());
    } catch (error) {
    }
  };


  return (
    <>
    {corporatemodel && (
          <div
            className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
            onClick={() => setCorporatemodel(false)}
          />
        )}
      <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          corporatemodel ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
          <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
          <div className="flex items-center">
            <div className="my-[7px] text-xl font-semibold text-gray-900">Add Branch</div>
            </div>
            <button
              onClick={() => {
                setCorporatemodel(false);
              }}
            >
              <MdClose className="text-2xl text-gray-500 hover:text-black" />
            </button>
          </div>
        <div className="flex-1 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
          <form onSubmit={handleSubmit} id="formId">
            <div className="flex flex-col gap-3 p-5 md:p-3 xl:p-5">
              <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Branch Name<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm w-full outline-[#FCDD00] input"
                    type="text"
                    placeholder="Enter Branch Name"
                    id="corporateName"
                    name="corporateName"
                    value={corporateName}
                    onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s@._-]/g, ''))
                    }
                    onChange={(e) => {
                      const enteredValue = e.target.value;
                      const trimmedValue = enteredValue.trim();
                      if (trimmedValue !== "" || enteredValue === "") {
                        setCorporateName(enteredValue);
                      }
                    }}
                    required
                    autoComplete="off"
                    maxLength={50}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Name<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm w-full outline-[#FCDD00]"
                    type="text"
                    placeholder="Enter Name"
                    id="name"
                    name="name"
                    value={name}
                    onInput={(e) =>
                    (e.target.value = e.target.value.replace(
                      /[^a-zA-Z0-9\s]/g,
                      ""
                    ))
                    }
                    onChange={(e) => {
                      const enteredValue = e.target.value;
                      const trimmedValue = enteredValue.trim();
                      if (trimmedValue !== "" || enteredValue === "") {
                        setName(enteredValue);
                      }
                    }}
                    required
                    autoComplete="off"
                    maxLength={50}
                  />
                </div>
              </div>
              <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Email Id<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm w-full outline-[#FCDD00]"
                    type="email"
                    placeholder="Enter Branch Email Id"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Contact No<span className="text-[#fc0000]">*</span> :
                  </span>
                  <input
                    className="py-[10px] xl:py-3 px-4 text-sm rounded-lg  bg-[#FFFCE1] w-full outline-[#FCDD00]"
                    type="tel"
                    placeholder="Enter Branch Contact No"
                    id="contact"
                    name="contact"
                    value={contactno}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9+]/g, ""))
                    }
                    onChange={(e) => {
                      setContactno(e.target.value);
                    }}
                    required
                    autoComplete="off"
                    // maxLength={10}
                    minLength={0}
                  />
                </div>
              </div>

              <div className="gap-3 md:flex">
             

                <div className="mt-2 md:mt-0">
                  <span className="font-Poppins text-[15px] xl:text-base ">
                    Add Logo<span className="text-[#fc0000]">*</span> :
                  </span>
                  <label htmlFor="inputTagsf" className="flex ">
                    <div className="bg-[#fff] w-[100px] h-[100px] xl:h-[105px] xl:w-[105px] overflow-hidden border-dashed border-2 border-[#FCDD00] flex items-center justify-center cursor-pointer  rounded-[10px] mt-[6px]">
                      <input
                        id="inputTagsf"
                        type="file"
                        accept="image/png, image/jpeg, image/jpg"
                        className="hidden"
                        onChange={onuploadimagechange}
                      />
                      {uploadimagesURLs && uploadimagesURLs[0] ? (
                        <div className="relative w-full h-full p-1 group">
                          <img
                            src={uploadimagesURLs}
                            className="w-full h-full rounded-[6px]"
                            alt="new"
                          ></img>
                          <div className="">
                            <div className="hidden group-hover:block absolute top-[50%] left-[50%] transform -translate-x-[50%] -translate-y-[50%]">
                              <img src={upload} className="mx-auto" />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-center justify-center h-full ">
                          <div className="text-center ">
                            <img src={upload} className="mx-auto" />
                            <p className="text-[#FCDD00] text-sm font-medium font-poppins">
                              Upload Image
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </label>
                  {errors.uploadimage && (
                    <div className="mt-2 text-[#FF0101] text-sm font-poppins">
                      {errors.uploadimage}
                    </div>
                  )}
                  {ImageValidationError && (
                    <p className="mt-2 text-[#FF0101] text-sm font-poppins">
                      {ImageValidationError}
                    </p>
                  )}
                </div>
              </div> 
               <div>
                  {error && (
                    <p className="mt-2 text-[#FF0101] text-sm font-poppins">
                      {error}
                    </p>
                  )}
                </div>
              {/* <div className="justify-between md:flex md:items-end">
  
                <div className="justify-end mt-2 ml-auto md:mt-0 md:flex">
                  <button
                    // onSubmit={handleSubmit}
                    type="submit"
                    className="bg-[#FCDD00] text-[#1A1A1A] w-[100px] px-5 py-2 rounded-lg font-Poppins text-lg flex items-center justify-center gap-1 cursor-pointer hover:scale-105 outline-none"
                  >
                    Save
                  </button>
                </div>
              </div> */}
            </div>
          </form>
        </div>
        <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
          <button
            type="submit"
            form="formId"
            className="w-full bg-[#FCDD00] text-black py-3 px-4 rounded-lg hover:bg-[#FCDD00] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 font-medium"
          >
            Save
          </button>
          <button
            onClick={() => setCorporatemodel(false)}
            className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};
